import React, { useState, useEffect } from 'react'
import { Col, Alert, Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { updateJob, getJobInformation } from '../../api/meeting.api'
import { takeChargeFromCustomer } from '../../api/stripe.api'
import { openNotificationWithIcon, isLiveUser, handleJobCompletion } from '../../utils'
import { appendGaAttributionToPayload } from '../../utils/gaAttribution'
import { checkCustomerHaveCard } from '../../services/FreeMinutePopupService'
import { Modal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClipboardList, faInfoCircle, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import mixpanel from 'mixpanel-browser'
import { JobTags, DISCOUNT_COUPON } from '../../constants'
import { CalculateDiscount } from '../../constants/calculateDiscount'
import * as JobCycleApi from '../../api/jobCycle.api'
import * as CustomerApi from '../../api/customer.api'
import * as JobApi from '../../api/job.api'
import { MAIN_APP_URL } from '../../constants'
import { trackProjectConversionGtmOnce } from '../../utils/gtm'

let liveUser = true

const PAYMENT_SETTINGS_PATH = '/customer/card-detail-page'

const showProjectPaymentFailedModal = (errorMessage) => {
	const paymentPageUrl = `${MAIN_APP_URL || ''}${PAYMENT_SETTINGS_PATH}`
	Modal.error({
		title: 'Payment failed',
		okText: 'OK',
		className: 'app-confirm-modal',
		content: (
			<div>
				<p>
					Your payment failed. Please update your payment method and try again.
				</p>
				<p>
					<a href={paymentPageUrl} target="_blank" rel="noopener noreferrer">
						Open payment settings{' '}
						<FontAwesomeIcon icon={faExternalLinkAlt} />
					</a>
				</p>
				<p>
				Once your payment information is updated, you can try approving the project again.
				</p>
				
			</div>
		),
	})
}

const LongJobDetails = (props) => {

	const [showApproveButtons, setShowApproveButtons] = useState(false)
	const [longJobHours, setLongJobHours] = useState(false)
	const [longJobCost, setLongJobCost] = useState(false)
	const [longJobMin, setLongJobMin] = useState(false)
	const [estimatedDeliveryTime, setEstimatedDeliveryTime] = useState(false)
	const [showLongJobDetails, setShowLongJobDetails] = useState(false)
	const [hoursValue, setHoursValue] = useState(2)
	const [fillHourSection, showFillHourSection] = useState(false)
	const [showLongJobButton, setShowLongJobButton] = useState(props.job.jobDuration == 'more than 2 hours' ? false : true)
	const [showWaitMessage, setShowWaitMessage] = useState(false)
	const [showApprovalMessage, setShowApprovalMessage] = useState(false)
	const [showRejectedMessage, setShowRejectedMessage] = useState(false)
	const [showWaitToCustMessage, setShowWaitToCustMessage] = useState(false)
	const [calculatedCost, setCalculatedCost] = useState(props.job.software.hourlyRate * 2)
	const [showContinueWithMinuteMessage, setShowContinueWithMinuteMessage] = useState(false)
	const [showContinueWithHours, setShowContinueWithHours] = useState(false)
	const [meetingWithMinutes, setMeetingWithMinutes] = useState(false)
	const [showContinueWithMinutes, setShowContinueWithMinutes] = useState(false)
	const [estimatedTime, setEstimatedTime] = useState('')
	const [discountedCost, setDiscountedCost] = useState(0)
	const [isButtonDisabled, setIsButtonDisabled] = useState(false)
	const [isFixedJobApproved, setIsFixedJobApproved] = useState('')
	const [isFullDiscountCoupon, setIsFullDiscountCoupon] = useState(false)
	const [projectScope, setProjectScope] = useState('')
	const [showProjectScopeError, setShowProjectScopeError] = useState(false)
	const [showCustomerRejectionOptions, setShowCustomerRejectionOptions] = useState(false)
	const [showTechnicianRejectionOptions, setShowTechnicianRejectionOptions] = useState(false)

	useEffect(() => {
		if (
			props.job.long_job_with_minutes === 'yes' &&
			(props.job.customer_approved_long_job === undefined || props.job.customer_approved_long_job === null)
		) {
			setMeetingWithMinutes(true)
			if (props.user.userType === 'technician') {
				setShowLongJobButton(false)
				setShowWaitMessage(true)
			}
			if (props.user.userType === 'customer') {
				setShowLongJobDetails(true)
				setShowApproveButtons(true)
				setShowContinueWithMinuteMessage(true)
			}
		}

		if (props.job.long_job_with_minutes == 'yes' && props.job.customer_approved_long_job === 'yes') {
			if (props.user.userType === 'technician') {
				props.setShowTransferButton(false)
			}
			setShowLongJobDetails(true)
			setShowContinueWithMinutes(true)
		}

		if (props.job.long_job_with_minutes == 'yes' && props.job.customer_approved_long_job === 'no') {
			if (props.user.userType === 'technician') {
				setShowRejectedMessage(true)
				setShowContinueWithMinuteMessage(false)
				setShowApprovalMessage(false)
				setShowWaitMessage(false)
				setShowLongJobButton(true)
				setShowTechnicianRejectionOptions(true)
				openNotificationWithIcon('error', 'Error', 'Project hours approval has been declined by the client.')
			}
			if (props.user.userType === 'customer') {
				setShowWaitToCustMessage(false)
				setShowCustomerRejectionOptions(true)
			}
		}
		if (
			props.job.long_job_cost &&
			props.job.long_job_hours &&
			(props.job.long_job_with_minutes == 'no' || props.job.long_job_with_minutes == 'undefined')
		) {
			if (props.user.userType === 'technician') {
				setShowLongJobButton(false)
				setShowWaitMessage(true)
				showLongJobHourDetails()
			}

			if (props.user.userType === 'customer') {
				setShowApproveButtons(true)
				showLongJobHourDetails()
			}
		}
		if (
			props.job.is_transferred &&
			(props.job.customer_approved_long_job === 'no' ||
				props.job.customer_approved_long_job === undefined ||
				props.job.customer_approved_long_job === null)
		) {
			setShowWaitMessage(false)
			setShowRejectedMessage(false)
			setShowWaitToCustMessage(false)
			setShowApproveButtons(false)
			setShowLongJobDetails(false)
			setShowLongJobButton(true)
		}
		if (props.job.customer_approved_long_job != undefined && props.job.customer_approved_long_job === 'yes') {
			props.setShowEndmeetingButton(false)
			setShowLongJobButton(false)
			if (props.job.long_job_with_minutes != undefined) {
				setShowContinueWithMinutes(true)
			} else {
				setShowContinueWithHours(true)
			}
		}
		if (props.job.is_long_job && props.job.long_job_cost && props.job.long_job_hours > 0 && props.user.userType === 'customer') {
			if (props.job.customer_approved_long_job === 'no') {
				setShowWaitToCustMessage(false)
				setShowCustomerRejectionOptions(true)
			}
			if (props.job.customer_approved_long_job === undefined) {
				setShowWaitToCustMessage(true)
			}
			if (props.job.customer_approved_long_job === 'yes') {
				setShowContinueWithMinutes(false)
				showLongJobHourDetails()
				setShowApproveButtons(false)
			}
		}

		if (props.job.is_long_job && props.job.long_job_cost && props.job.long_job_hours > 0 && props.user.userType === 'technician') {
			if (props.job.customer_approved_long_job === 'yes') {
				props.setShowTransferButton(false)
				props.setEnableStartPauseTimerButton(false)
				showFillHourSection(false)
				setShowWaitMessage(false)
				setShowLongJobButton(false)
				setShowApprovalMessage(false)
				if (props.job.long_job_with_minutes === 'yes') {
					setShowContinueWithMinutes(true)
				} else {
					showLongJobHourDetails()
					setShowContinueWithMinutes(false)
				}
			} else if (props.job.customer_approved_long_job === 'no') {
				showFillHourSection(true)
				setShowWaitMessage(false)
				setShowLongJobButton(true)
				setShowRejectedMessage(true)
				setShowTechnicianRejectionOptions(true)
				setShowContinueWithMinuteMessage(false)
			} else if (props.job.customer_approved_long_job === undefined) {
				showFillHourSection(false)
				setShowWaitMessage(true)
				setShowLongJobButton(false)
			}
		}

		if (props.job.jobDuration == 'more than 2 hours' && props.job.long_job_with_minutes == undefined) {
			console.log('inside if part ..... more than 2 hours')
			showFillHourSection(true)
		}

	}, [props.job])
	useEffect(() => {
		if (props.user.userType == 'technician' && props.job.discount_type == "percentage" && props.job.coupon_code_discount == DISCOUNT_COUPON) {
			setIsFullDiscountCoupon(true);

		}
	}, [props.job])

	useEffect(() => {
		if (props.newCardAdded && props.approveClicked) {
			changeJobtoLongJob()
		}
	}, [props.newCardAdded])

	useEffect(() => {
		if (props.socket) {
			/**
			 * This socket is sent by technician to client while sending Project hours estimation.
			 * @params =  data of the socket
			 * @response : no response
			 * @author : Manibha
			 */
			props.socket.on('Submitted:hours', async (socketData) => {

				console.log('Submitted:hours', socketData)

				if (socketData && socketData.jobId && props.job.id && socketData.jobId === props.job.id) {
					// Reset rejection states when new proposal is received
					setShowCustomerRejectionOptions(false)
					setShowWaitToCustMessage(false)
					
					if (socketData.long_job_with_minutes !== undefined) {
						setMeetingWithMinutes(true)
						setShowContinueWithMinuteMessage(true)
						setShowContinueWithHours(false)
						setShowApproveButtons(true)
						setShowLongJobDetails(true)
						setProjectScope(socketData.projectScope)
					} else {
						setMeetingWithMinutes(false)
						setShowContinueWithMinuteMessage(false)
						setShowContinueWithHours(true)
						setLongJobHours(socketData.hoursValue)
						setLongJobCost(socketData.cost)
						setEstimatedDeliveryTime(socketData.estimated_time)
						setLongJobMin(socketData.minsValue)
						setShowApproveButtons(true)
						setShowLongJobDetails(true)
						setProjectScope(socketData.projectScope)
					}
					
					// Notify customer about revised proposal
					openNotificationWithIcon(
						'info', 
						'New Proposal', 
						'Technician has submitted a revised proposal for your review.'
					)
					
					if (props.job && props.job.coupon_code_discount) {
						const discountData = {
							totalCost: parseInt(props.job.software.hourlyRate) * socketData.hoursValue,
							discountedValue: props.job && props.job.coupon_code_discount ? parseInt(props.job.coupon_code_discount) : 0,
							discountType: props.job && props.job.discount_type ? props.job.discount_type : 'NA',
						}
						const calculateCost = CalculateDiscount(discountData.totalCost, discountData.discountedValue, discountData.discountType)
						setDiscountedCost(calculateCost)
					}
				}
			})

			/**
			 * This socket is sent by client to technician while replying to the project hours estimation.
			 * @params =  data of the socket
			 * @response : no response
			 * @author : Manibha
			 */
			props.socket.on('Submitted:confirmedHours', async (socketData) => {
				if (socketData && socketData.jobId && props.job.id && socketData.jobId === props.job.id && props.user.userType === 'technician') {
					if (socketData.long_job_confirmed === 'yes') {
						console.log('>>>>>>>>>>>>>  project confirmed   >>>>>>>>>')
						if (socketData.meetingWithMinutes == undefined || socketData.meetingWithMinutes == false) {
							setShowContinueWithMinutes(false)
							props.setIntialTimeVal(0)
							setShowContinueWithHours(true)
							setShowContinueWithMinuteMessage(false)
							props.setEnableStartPauseTimerButton(false)
						} else {
							setShowContinueWithMinuteMessage(false)
							setMeetingWithMinutes(true)
							setShowContinueWithMinutes(true)
						}

						props.setShowTransferButton(false)

						setShowWaitMessage(false)
						setShowApprovalMessage(true)
						setShowRejectedMessage(false)
						props.setShowEndmeetingButton(false)
						openNotificationWithIcon(
							'success',
							'Success',
							`Your request to convert to a project was confirmed! Please click the "Leave Meeting" button below. This will take you back to the dashboard, where you'll be able to chat with your customer, and get the required information necessary to complete the request.`,
						)
						const jobInfoResponse = await getJobInformation(socketData.jobId, props?.user?.id)
						const jobInfo = jobInfoResponse.success ? jobInfoResponse.data : {}
						if (jobInfo.id != undefined) {
							setLongJobHours(jobInfo.long_job_hours)
							setLongJobCost(jobInfo.long_job_cost)
							setLongJobMin(jobInfo.long_job_subscription)
							setProjectScope(jobInfo.projectScope)
							setEstimatedDeliveryTime(jobInfo.estimated_time)
							setShowLongJobDetails(true)
							// // Checking if total discounted cost is availale . If available the send it to the state
							// const cost = jobInfo && jobInfo.total_discounted_cost && jobInfo.total_discounted_cost!=undefined ? jobInfo.total_discounted_cost : 0
							// setDiscountedCost(cost)
						}
					} else if (socketData.long_job_confirmed === 'no') {
						// console.log('LongjobDetails::customer did no>>>>>>>>>>>>>')
						setShowRejectedMessage(true)
						setShowTechnicianRejectionOptions(true)
						setShowContinueWithMinuteMessage(false)
						setShowApprovalMessage(false)
						setShowWaitMessage(false)
						setShowLongJobButton(true)
						if (socketData.meetingWithMinutes == undefined) {
							showFillHourSection(true)
						}
						openNotificationWithIcon(
							'error',
							'Error',
							socketData.payment_failed
								? 'Project conversion was blocked because the customer payment failed.'
								: 'Project hours approval has been declined by the client.',
						)
					}
				}
			})

			/**
			 * This socket handles when either customer or technician chooses to exit project flow
			 * @params = data of the socket
			 * @response = no response
			 * @author = GitHub Copilot
			 */
			props.socket.on('Project:exitFlow', async (socketData) => {
				if (socketData && socketData.jobId && props.job.id && socketData.jobId === props.job.id) {
					// Reset all project-related states
					setShowLongJobDetails(false)
					setShowApproveButtons(false)
					setShowWaitToCustMessage(false)
					setShowCustomerRejectionOptions(false)
					setShowTechnicianRejectionOptions(false)
					setShowRejectedMessage(false)
					showFillHourSection(false)
					
					// Re-enable regular meeting controls
					props.setShowEndmeetingButton(true)
					props.setShowTransferButton && props.setShowTransferButton(true)
					
					openNotificationWithIcon('info', 'Info', 'Project flow cancelled. Continuing with regular meeting.')
				}
			})
		}
	}, [props.socket])

	/*useEffect(() =>{long_job_hours
		if(props.job &&  props.job.coupon_code_discount && longJobCost ){
			const discountData = {
				totalCost : parseInt(props.job.software.hourlyRate) * socketData.hoursValue,
				discountedValue : props.job && props.job.coupon_code_discount ?parseInt(props.job.coupon_code_discount) : 0,
				discountType :  props.job && props.job.discount_type ? props.job.discount_type : "NA"
			}
			console.log("discountData", discountData)
			const calculateCost = CalculateDiscount(discountData.totalCost , discountData.discountedValue , discountData.discountType)
			setDiscountedCost(calculateCost)
		}else{
			setDiscountedCost(0)
		}
	},[longJobCost])*/

	useEffect(() => {
		; (async () => {
			liveUser = await isLiveUser(props.job)
		})()
	})


	/**
	 * Function will show the project with hours section.
	 * @params =  no params
	 * @response : no response
	 * @author : Manibha
	 */
	const showLongJobHourDetails = () => {
		setShowLongJobDetails(true)
		setShowContinueWithHours(true)
		setLongJobHours(props.job.long_job_hours)
		setProjectScope(props.job.projectScope)
		setLongJobCost(props.job.long_job_cost)
		setLongJobMin(props.job.long_job_subscription)
		setEstimatedDeliveryTime(props.job.estimated_time)

		if (props.job && props.job.coupon_code_discount) {
			const discountData = {
				totalCost: parseInt(props.job.software.hourlyRate) * parseInt(props.job.long_job_hours),
				discountedValue: parseInt(props.job.coupon_code_discount),
				discountType: props.job.discount_type ? props.job.discount_type : 'NA',
			}

			const calculateCost = CalculateDiscount(discountData.totalCost, discountData.discountedValue, discountData.discountType)
			setDiscountedCost(calculateCost)
		}
	}

	/**
	 * Function will run if customer confirms the approval of hours send by technician.It will take charge from customer if the job is of fixed hours.
	 * @params =  no params
	 * @response : no response
	 * @author : Manibha
	 */
	// const changeJobtoLongJob = async () => {
	// 	if (!meetingWithMinutes) {
	// 		const charge = await takeChargeFromCustomer({
	// 			job_id: props.job.id,
	// 			user_id: props?.job?.customer?.user?.id,
	// 			liveUser: liveUser,
	// 			cuId: props.user?.id,
	// 		})
	// 		console.log('LongjobDetails::takeChargeFromCustomer>>>>>>>>', charge)
	// 		if (charge?.data?.success && charge?.data?.status == 'Successful') {
	// 			convertToLongJob()
	// 		} else {
	// 			setIsButtonDisabled(false)
	// 			openNotificationWithIcon(
	// 				'error',
	// 				'Error',
	// 				'Your card transaction has been failed.Try adding another card in dashboard settings tab and make it default.You can come back to this meeting then and try approving the project again.',
	// 			)
	// 			setIsFixedJobApproved('If you have changed the card please refresh the page and then try again')
	// 		}
	// 	} else {
	// 		convertToLongJob()
	// 	}
	// }

	// const changeJobtoLongJob = async () => {
	// 	if (!meetingWithMinutes) {
	// 		console.log('=== Starting changeJobtoLongJob with credit check ===')
	// 		console.log('Job details:', props.job, longJobHours)
	// 		const cost = longJobHours * 60
	// 		const jobData = {
	// 			id: props.job.id,
	// 			totalCost: cost || 0,
	// 			customerEmail: props?.job?.customer?.user?.email,
	// 			totalJobTime: props?.job?.total_time,
	// 			customer: props?.job?.customer,
	// 			technician: props?.job?.technician,
	// 			software: props?.job?.software,
	// 			bulkSubscriptionApplied: props?.job?.bulkSubscriptionApplied || false,
	// 			purchasedProductId: props?.job?.purchasedProductId || null,
	// 			autoRenew:props?.job?.autoRenew || false,
	// 			technician: props?.job?.technician,
	// 			jobDescription: props?.job?.issueDescription || "",
	// 			long_job_hours: props?.job?.total_time || longJobHours,
	// 			JobId: props?.job?.JobId
	// 		}

	// 		try {
	// 			console.log('Prepared job data for credit processing:', jobData,props?.job)

	// 			const creditResult = await handleJobCompletion(jobData, props.socket)
	// 			console.log('Credit result:', creditResult)
	// 			const jobUpdateData = {}
	// 			if (creditResult.chargedNormally) {
	// 				// Either no credits OR mixed payment
	// 				console.log('Charging normally (credits insufficient or partial)')
	// 				let chargeAmount = creditResult.amount || props?.job?.total_cost

	// 				if (creditResult.creditsUsed && creditResult.remainingCost) {
	// 					chargeAmount = creditResult.remainingCost
	// 					console.log(`Mixed payment: used ${creditResult.creditsUsed} credits, charging ${chargeAmount}`)
	// 				}
	// 				// Set minimal tracking for mixed payment
	// 				jobUpdateData.creditSubscription = true
	// 				jobUpdateData.creditsUsed = creditResult.creditsUsed
	// 				jobUpdateData.remainingCostCharged = creditResult.remainingCost
	// 				jobUpdateData.payment_type = 'credits_and_card'
	// 				// if (Object.keys(jobUpdateData).length > 0) {
	// 				// 	// await JobApi.updateJob(props.job.id, jobUpdateData);
	// 				// 	console.log('Job updated with credit information:', jobUpdateData)
	// 				// 	const updateStatus = await updateJob(props.job.id, {
	// 				// 		dataToUpdate: jobUpdateData,
	// 				// 		cuId: props.user?.id,
	// 				// 	})
	// 				// }
	// 				// setLongJobCost(chargeAmount)
	// 				const charge = await takeChargeFromCustomer({
	// 					job_id: props.job.id,
	// 					user_id: props?.job?.customer?.user?.id,
	// 					liveUser: liveUser,
	// 					cuId: props.user?.id,
	// 					jobUpdateData,
	// 				})

	// 				console.log('Charge result:', charge)
	// 				props.socket.emit("credit-system-update-detail", {
	// 					jobId: props.job.id,
	// 					UserId: props?.job?.customer?.user?.id,
	// 				});
	// 				if (charge?.data?.success && charge?.data?.status === 'Successful') {
	// 					convertToLongJob()
	// 				} else {
	// 					setIsButtonDisabled(false)
	// 					openNotificationWithIcon(
	// 						'error',
	// 						'Error',
	// 						'Your card transaction has failed. Try adding another card in dashboard settings and set it as default. Then return to this meeting and try again.',
	// 					)
	// 					setIsFixedJobApproved('If you have changed the card, please refresh the page and try again.')
	// 				}
	// 			} else {
	// 				jobUpdateData.creditSubscription = true
	// 				jobUpdateData.creditsUsed = creditResult.creditsUsed
	// 				jobUpdateData.remainingCostCharged = 0
	// 				jobUpdateData.payment_type = 'credits_only'
	// 				jobUpdateData.payment_status = 'Successful'
	// 				// Fully covered by credits
	// 				console.log('Job fully paid by credits — converting directly.')
	// 				convertToLongJob()
	// 			}
	// 			if (Object.keys(jobUpdateData).length > 0) {
	// 				// await JobApi.updateJob(props.job.id, jobUpdateData);
	// 				console.log('Job updated with credit information:', jobUpdateData)
	// 				const updateStatus = updateJob(props.job.id, {
	// 					dataToUpdate: jobUpdateData,
	// 					cuId: props.user?.id,
	// 				})
	// 			}
	// 			props.socket.emit("credit-system-update-detail", {
	// 				jobId: props.job.id,
	// 				UserId: props?.job?.customer?.user?.id,
	// 			});

	// 		} catch (error) {
	// 			console.error('Error in credit flow, falling back to direct charge:', error)

	// 			const charge = await takeChargeFromCustomer({
	// 				job_id: props.job.id,
	// 				user_id: props?.job?.customer?.user?.id,
	// 				liveUser: liveUser,
	// 				cuId: props.user?.id,
	// 			})

	// 			console.log('Fallback charge result:', charge)

	// 			if (charge?.data?.success && charge?.data?.status === 'Successful') {
	// 				convertToLongJob()
	// 			} else {
	// 				setIsButtonDisabled(false)
	// 				openNotificationWithIcon(
	// 					'error',
	// 					'Error',
	// 					'Your card transaction has failed. Try adding another card in dashboard settings and set it as default. Then return to this meeting and try again.',
	// 				)
	// 				setIsFixedJobApproved('If you have changed the card, please refresh the page and try again.')
	// 			}
	// 		}

	// 		console.log('=== Finished changeJobtoLongJob ===')
	// 	} else {
	// 		convertToLongJob()
	// 	}
	// }
	const changeJobtoLongJob = async () => {
		if (!meetingWithMinutes) {
			console.log('Long-Job-Tracking:: changeJobtoLongJob function called')
			try {
				// Check if customer has bulk credits
				const hasBulkCredits =
					props.job.bulkSubscriptionApplied === true ||
					(props.job.customer?.bulk_credits?.purchase_history?.length > 0);

				if (hasBulkCredits) {
					// Use credit system
					console.log("🪙 Bulk credit or subscription detected → Using credit system...");

					const hours =
						Number(longJobHours) || Number(props.job.long_job_hours) || 0;
					const hourlyRate = Number(props.job.software?.hourlyRate) || 0;
					const costFromRate =
						hours > 0 && hourlyRate > 0 ? hours * hourlyRate : 0;
					const cost =
						(Number(longJobCost) > 0 ? Number(longJobCost) : 0) ||
						costFromRate ||
						0;
					const jobData = {
						id: props.job.id,
						totalCost: cost,
						customerEmail: props?.job?.customer?.user?.email,
						totalJobTime: props?.job?.total_time,
						customer: props?.job?.customer,
						technician: props?.job?.technician,
						software: props?.job?.software,
						bulkSubscriptionApplied: props?.job?.bulkSubscriptionApplied || false,
						purchasedProductId: props?.job?.purchasedProductId || null,
						autoRenew: props?.job?.autoRenew || false,
						jobDescription: props?.job?.issueDescription || "",
						long_job_hours: hours || longJobHours,
						JobId: props?.job?.JobId
					};

					console.log('Prepared job data for credit processing:', jobData);

					const creditResult = await handleJobCompletion(jobData, props.socket);
					console.log('Credit result:', creditResult);

					if (creditResult.purchaseFailed) {
						setIsButtonDisabled(false);
						showProjectPaymentFailedModal(
							creditResult.reason || 'Failed to process your credit plan purchase. Please update your payment method and try again.'
						);
						return;
					}

					const jobUpdateData = {};
					const planCharged = Number(creditResult.totalCharged);
					if (Number.isFinite(planCharged) && planCharged > 0) {
						jobUpdateData.bulkPlanAmountCharged = planCharged;
					}

					if (creditResult.chargedNormally) {
						// Mixed payment: credits + card
						console.log('💳 Partial credit use or insufficient credits → charging balance...');

						jobUpdateData.creditSubscription = true;
						jobUpdateData.creditsUsed = creditResult.creditsUsed;
						jobUpdateData.remainingCostCharged = creditResult.remainingCost;
						jobUpdateData.payment_type = 'credits_and_card';

						const charge = await takeChargeFromCustomer({
							job_id: props.job.id,
							user_id: props?.job?.customer?.user?.id,
							liveUser: liveUser,
							cuId: props.user?.id,
							jobUpdateData,
						});

						console.log('LongjobDetails::takeChargeFromCustomer>>>>>>>>', charge);

						props.socket.emit("credit-system-update-detail", {
							jobId: props.job.id,
							UserId: props?.job?.customer?.user?.id,
						});

						if (charge?.data?.success && charge?.data?.status === 'Successful') {
							convertToLongJob({
								creditsUsed: creditResult.creditsUsed,
								remainingCostCharged: creditResult.remainingCost,
							});
						} else {
							setIsButtonDisabled(false);
							const errorMessage =
								charge?.data?.message ||
								charge?.message ||
								'Your card payment failed. Project conversion did not proceed.';
							showProjectPaymentFailedModal(errorMessage);
							setIsFixedJobApproved('If you have changed the card please refresh the page and then try again');
						}
					} else {
						// Fully paid by credits
						console.log('🪙 Job fully paid via credits');

						jobUpdateData.creditSubscription = true;
						jobUpdateData.creditsUsed = creditResult.creditsUsed;
						jobUpdateData.remainingCostCharged = 0;
						jobUpdateData.payment_type = 'credits_only';
						jobUpdateData.payment_status = 'Successful';

						props.socket.emit("credit-system-update-detail", {
							jobId: props.job.id,
							UserId: props?.job?.customer?.user?.id,

						});
						if (Object.keys(jobUpdateData).length > 0) {
							console.log('Job updated with credit information:', jobUpdateData);
							await updateJob(props.job.id, {
								dataToUpdate: jobUpdateData,
								cuId: props.user?.id,
							});
						}

						convertToLongJob({
							creditsUsed: creditResult.creditsUsed,
							remainingCostCharged: 0,
						});

					}


				} else {
					// Normal (Stripe) charge system - original flow
					console.log("💳 No bulk credits found → Using normal charge system...");

					const charge = await takeChargeFromCustomer({
						job_id: props.job.id,
						user_id: props?.job?.customer?.user?.id,
						liveUser: liveUser,
						cuId: props.user?.id,
					});

					console.log('LongjobDetails::takeChargeFromCustomer>>>>>>>>', charge);

					if (charge?.data?.success && charge?.data?.status === 'Successful') {
						convertToLongJob();
					} else {
						setIsButtonDisabled(false);
						const errorMessage =
							charge?.data?.message ||
							charge?.message ||
							'Your card payment failed. Project conversion did not proceed.';
						showProjectPaymentFailedModal(errorMessage);
						setIsFixedJobApproved('If you have changed the card please refresh the page and then try again');
					}
				}

			} catch (error) {
				console.error('Error in changeJobtoLongJob:', error);
				setIsButtonDisabled(false);
				showProjectPaymentFailedModal(
					error?.message || 'An error occurred during payment processing. Please try again.',
				);
			}
		} else {
			convertToLongJob();
		}
	};

	/**
	 * Runs when the customer confirms project approval; charges if fixed hours, updates the job,
	 * fires GTM events, and notifies the technician via socket.
	 */
	const convertToLongJob = async (settlementCredits = null) => {
		console.log('Long-Job-Tracking:: convertToLongJob function called')
		// console.log('set Continue with minutes ::::::: ', showContinueWithMinutes)
		setShowContinueWithMinuteMessage(false)
		if (!meetingWithMinutes) {
			props.setIntialTimeVal(0)
			setShowContinueWithHours(true)
		} else {
			setShowContinueWithMinutes(true)
		}

		const dataToUpdate = {
			projectScope: projectScope,
			customer_approved_long_job: 'yes',
			status: 'long-job',
		}

		//appendGaAttributionToPayload(dataToUpdate)
		console.log('dataToUpdate when converting to long job', dataToUpdate)
		const updateResult = await updateJob(props.job.id, {
			dataToUpdate: dataToUpdate,
			cuId: props.user?.id,
		})

		if (!updateResult?.success) {
			setIsButtonDisabled(false)
			openNotificationWithIcon(
				'error',
				'Error',
				'Your project approval could not be saved. Please try again.',
			)
			return
		}

		await trackProjectConversionGtmOnce({
			job: props.job,
			user: props.user,
			longJobCost,
			discountedCost,
			meetingWithMinutes,
			appUrlBase: MAIN_APP_URL,
			updateJobFn: updateJob,
		})

		const data = {}
		data['jobId'] = props.job.id
		data['long_job_confirmed'] = 'yes'
		data['customer_id'] = props.job.customer.user.id
		data['technician_id'] = props.job.technician.user.id
		data['software_name'] = props.job.software.name
		data['meetingWithMinutes'] = meetingWithMinutes
		data['customer_phonenumber'] = props.job.customer.phoneNumber
		data['tag'] = props?.job?.technician?.tag
		try {
			data['technician_toggle'] = props.job.technician['profile']['alertPreference']['settings']['Job']['Text']['toggle']
			data['technician_phonenumber'] = props.job.technician['profile']['alertPreference']['settings']['Job']['Text']['value']
		} catch (err) {
			// console.log('LongjobDetails::did not find any number to send Project text')
			data['technician_phonenumber'] = ''
			data['technician_toggle'] = ''
		}
		props.socket.emit('SendHours:confirmed', data)
		const earningPayload = {
			jobId: props.job.id,
			customer: props.job.customer.user.id,
			technician: props.job.technician.user.id,
		}
		if (settlementCredits && Number(settlementCredits.creditsUsed) > 0) {
			earningPayload.creditsUsed = Number(settlementCredits.creditsUsed)
			earningPayload.remainingCostCharged = Number(
				settlementCredits.remainingCostCharged
			) || 0
		}
		props.socket.emit("createEarningReport", earningPayload);

		
		props.setShowEndmeetingButton(false)
		setShowApproveButtons(false)
		setShowWaitToCustMessage(false)
		setProjectScope(props.job.projectScope)
		openNotificationWithIcon(
			'success',
			'Success',
			`${props.user.firstName}, your request to convert to a project was confirmed! Please click the "Leave Meeting" button below. This will take you back to the dashboard, where you'll be able to communicate with your technician. Looking forward to solving your request!`,
		)
		if (!meetingWithMinutes) {
			props.socket.emit('Pause:timer', data)
		}
		// mixpanel code
		mixpanel.identify(props.job.customer.user.email)
		mixpanel.track('Meeting converted to project', { Data: data })
		// mixpanel code
	}

	/**
	 * Function will run if customer click on reject button to reject the hours sent by technician.
	 * It also sends socket to technician for rejection by customer.
	 * @params =  no params
	 * @response : no response
	 * @author : Manibha
	 */
	const rejectLongJob = async () => {
		setIsButtonDisabled(true)
		console.log('LongjobDetails::rejectLongJob>>>>>>>>>')
		const data = {}
		data['jobId'] = props.job.id
		data['long_job_confirmed'] = 'no'

		const updateStatus = updateJob(props.job.id, {
			dataToUpdate: { customer_approved_long_job: 'no', projectScope: projectScope },
			cuId: props.user?.id,
		})
		props.socket.emit('SendHours:confirmed', data)
		setShowWaitToCustMessage(false)
		setShowApproveButtons(false)
		setShowContinueWithMinuteMessage(false)
		setShowCustomerRejectionOptions(true)
		openNotificationWithIcon('success', 'Success', 'Project has been rejected.')
		await JobCycleApi.create(JobTags.CUSTOMER_REJECT_LONG_JOB, props.job.id)

		// Add telemetry for rejection
		if (props.user) {
			mixpanel.identify(props.user.email)
			mixpanel.track('Customer - Rejected Project Proposal', { 
				JobId: props.job.id,
				ProjectScope: projectScope,
				ProposedHours: props.job.long_job_hours,
				ProposedCost: props.job.long_job_cost
			})
		}

		setTimeout(() => {
			setIsButtonDisabled(false)
		}, 2000)
	}

	/**
	 * Function to handle customer choosing to continue with regular meeting after rejection
	 * @params = no params
	 * @response = no response
	 * @author = GitHub Copilot
	 */
	const continueWithRegularMeeting = async () => {
		setIsButtonDisabled(true)
		
		// Reset project-related states
		setShowCustomerRejectionOptions(false)
		setShowLongJobDetails(false)
		setShowApproveButtons(false)
		setShowWaitToCustMessage(false)
		
		// Re-enable regular meeting controls
		props.setShowEndmeetingButton(true)
		props.setShowTransferButton && props.setShowTransferButton(true)
		
		// Update job to remove project status
		await updateJob(props.job.id, {
			dataToUpdate: { 
				customer_approved_long_job: null,
				long_job_with_minutes: null,
				projectScope: null
			},
			cuId: props.user?.id,
		})

		// Notify technician
		const data = {
			jobId: props.job.id,
			action: 'continue_regular_meeting',
			customer_id: props.job.customer.user.id,
			technician_id: props.job.technician.user.id
		}
		props.socket.emit('Project:exitFlow', data)

		// Add telemetry
		if (props.user) {
			mixpanel.identify(props.user.email)
			mixpanel.track('Customer - Continue Regular Meeting After Rejection', { JobId: props.job.id })
		}

		// Add job cycle tracking
		await JobCycleApi.create(JobTags.CUSTOMER_EXIT_PROJECT_FLOW, props.job.id)

		openNotificationWithIcon('success', 'Success', 'Continuing with regular meeting.')
		
		setTimeout(() => {
			setIsButtonDisabled(false)
		}, 1000)
	}

	/**
	 * Function to handle technician choosing to continue with regular meeting after rejection
	 * @params = no params
	 * @response = no response
	 * @author = GitHub Copilot
	 */
	const technicianContinueRegularMeeting = async () => {
		setIsButtonDisabled(true)
		
		// Reset project-related states
		setShowTechnicianRejectionOptions(false)
		setShowRejectedMessage(false)
		setShowLongJobButton(true)
		showFillHourSection(false)
		
		// Re-enable regular meeting controls
		props.setShowEndmeetingButton(true)
		props.setShowTransferButton && props.setShowTransferButton(true)
		
		// Update job to remove project status
		await updateJob(props.job.id, {
			dataToUpdate: { 
				customer_approved_long_job: null,
				long_job_with_minutes: null,
				projectScope: null
			},
			cuId: props.user?.id,
		})

		// Notify customer
		const data = {
			jobId: props.job.id,
			action: 'continue_regular_meeting',
			customer_id: props.job.customer.user.id,
			technician_id: props.job.technician.user.id
		}
		props.socket.emit('Project:exitFlow', data)

		// Add telemetry
		if (props.user) {
			mixpanel.identify(props.user.email)
			mixpanel.track('Technician - Continue Regular Meeting After Rejection', { JobId: props.job.id })
		}

		// Add job cycle tracking
		await JobCycleApi.create(JobTags.TECHNICIAN_EXIT_PROJECT_FLOW, props.job.id)

		openNotificationWithIcon('success', 'Success', 'Continuing with regular meeting.')
		
		setTimeout(() => {
			setIsButtonDisabled(false)
		}, 1000)
	}

	/**
	 * Function will run if customer click on approve button to approve the hours sent by technician.
	 * It also confirms the approval.It calls a function further if customer confirms yes to approval.
	 * @params =  no params
	 * @response : no response
	 * @author : Manibha
	 */
	const approveLongJob = () => {
		if (props.user) {
			mixpanel.identify(props.user.email)
			mixpanel.track('Customer- Click on Approve button to approve project', { JobId: props.job.id })
		}
		Modal.confirm({
			title: 'Do you want to convert this job into a project?',
			okText: 'Yes',
			cancelText: 'No',
			className: 'app-confirm-modal',
			async onOk() {
				setIsButtonDisabled(true)
				props.setApproveClicked(true)

				let ownerId = props?.job?.customer?.user?.ownerId
				let customerId = props?.job?.customer?.id
				if (ownerId) {
					const ownerCustomerDetails = await CustomerApi.getCustomer(ownerId, props?.job?.customer?.user?.id)
					customerId = ownerCustomerDetails.id
				}
				const haveCard = await checkCustomerHaveCard(
					customerId,
					props?.job?.customer?.user?.id ? props?.job?.customer?.user?.id : props?.job?.customer?.user,
				)
				console.log('LongjobDetails::haveCard>>>>>>>>>>>>>>>>>', haveCard)

				if (haveCard) {
					setIsButtonDisabled(true)
					changeJobtoLongJob()
					if (props.user) {
						mixpanel.identify(props.user.email)
						mixpanel.track('Customer- Click on Yes button and approve Project', { JobId: props.job.id })
					}
					await JobCycleApi.create(JobTags.CUSTOMER_APPROVE_LONG_JOB, props.job.id)
				} else {
					if (ownerId) {
						props.openAddCardModal(true)
						setIsButtonDisabled(false)
						openNotificationWithIcon('error', 'Error', 'Sorry. You do not have card.')
					} else {
						openNotificationWithIcon('error', 'Error', 'Please contact your organisation owner to add card to proceed further.')
					}
				}
			},
		})
	}

	/**
	 * Function will run on value change of fill hour input. It checks the validation of input.
	 * @params =  target event
	 * @response : no response
	 * @author : Manibha
	 */

	const changeHourValue = (event) => {
		let newHrValue = parseFloat(event.target.value)
		if (newHrValue < 2) {
			setHoursValue(2)
			return openNotificationWithIcon('error', 'Error', 'Please input a number greater than 1.')
		}
		if (Number.isInteger(newHrValue) === false) {
			return openNotificationWithIcon('error', 'Error', 'Please input a whole number greater than 1.')
		}
		if (newHrValue > 1 && Number.isInteger(newHrValue)) {
			let cost = parseFloat(props.job.software.hourlyRate) * newHrValue
			setHoursValue(newHrValue)
			setCalculatedCost(cost)
			if (props.user) {
				mixpanel.identify(props.user.email)
				mixpanel.track(`Technician - Selected ${newHrValue} hour's for fixed hour Project`, { JobId: props.job.id })
			}
		}
	}

	/**
	 * It checks the validation of date/time input.
	 * @params =  target event
	 * @response : no response
	 * @author : Utkarsh Dixit
	 */
	const checkEstimtedTime = (event) => {
		const selectedDateTime = event.target.value
		const currentDateTime = new Date()
		const selectedDate = new Date(selectedDateTime)
		const minimumDateTime = new Date(currentDateTime.getTime() + 2 * 60 * 60 * 1000) // 2 hours from now
		
		if (!selectedDateTime) {
			return openNotificationWithIcon('error', 'Error', 'Please select a delivery date and time.')
		}
		
		if (selectedDate <= currentDateTime) {
			return openNotificationWithIcon('error', 'Error', 'Please select a future date and time.')
		}
		
		if (selectedDate < minimumDateTime) {
			return openNotificationWithIcon('error', 'Error', 'Please select a delivery time that is at least 2 hours from now.')
		}
		
		setEstimatedTime(selectedDateTime)
	}

	/**
	 * Function will send the hours filled by technician to customer using socket
	 * @params =  no params
	 * @response : no response
	 * @author : Manibha
	 */

	const sendHoursToCustomer = () => {
		if (props.user) {
			mixpanel.identify(props.user.email)
			mixpanel.track('Technician - Click on Submit for Project', { JobId: props.job.id })
		}

		// Validate project scope
		if (!projectScope.trim()) {
			setShowProjectScopeError(true)
			openNotificationWithIcon('error', 'Error', 'Please provide detailed project scope before proceeding.')
			return
		}
		setShowProjectScopeError(false)

		// Validate estimated delivery time
		if (!estimatedTime) {
			openNotificationWithIcon('error', 'Error', 'Please select an estimated delivery date and time.')
			return
		}

		const selectedDate = new Date(estimatedTime)
		const currentDate = new Date()
		const minimumDate = new Date(currentDate.getTime() + 2 * 60 * 60 * 1000) // 2 hours from now
		
		if (selectedDate <= currentDate) {
			openNotificationWithIcon('error', 'Error', 'Please select a future date and time for delivery.')
			return
		}

		if (selectedDate < minimumDate) {
			openNotificationWithIcon('error', 'Error', 'Please select a delivery time that is at least 2 hours from now.')
			return
		}

		Modal.confirm({
				title: `Are you sure you want to submit? The time you submitted for the job length is ${hoursValue} hours.`,
				content: (
					<div>
						<p>Project Scope:</p>
						<p style={{ whiteSpace: 'pre-wrap' }}>{projectScope}</p>
					</div>
				),
				okText: 'Confirm',
				cancelText: 'Go back',
				className: 'app-confirm-modal',
				async onOk() {
					setIsButtonDisabled(true)
					localStorage.removeItem('longJobPopUp')
					if (props.user) {
						mixpanel.identify(props.user.email)
						mixpanel.track('Technician - Click on Yes button to convert job into Project fixed hours', { JobId: props.job.id })
					}


					// Calculate discounted cost
					const discountData = {
						totalCost: parseInt(props.job.software.hourlyRate) * hoursValue,
						discountedValue: props.job && props.job.coupon_code_discount ? parseInt(props.job.coupon_code_discount) : 0,
						discountType: props.job && props.job.discount_type ? props.job.discount_type : 'NA',
					}
					const calculateCost = CalculateDiscount(discountData.totalCost, discountData.discountedValue, discountData.discountType)
					setDiscountedCost(calculateCost)

					// Send fixed hours project data
					const data = {
						jobId: props.job.id,
						projectScope: projectScope,
						estimated_time: estimatedTime,
						hoursValue: hoursValue,
						cost: parseInt(props.job.software.hourlyRate) * hoursValue,
						minsValue: hoursValue * 60,
						total_discounted_cost: calculateCost
					}
					props.socket.emit('SendHours:submitted', data)
					showFillHourSection(false)
					setShowLongJobButton(false)
					setShowWaitMessage(true)
					setShowRejectedMessage(false)
					setShowApprovalMessage(false)

					// Create lifecycle event for fixed hours project
					await JobCycleApi.create(JobTags.TECHINCIAN_SELECT_FIXED_LONG_JOB, props.job.id)
				}

			})
			setTimeout(() => {
				setIsButtonDisabled(false)
			}, 3000)

	}

	const openFillHourSection = async () => {
		if (props.user) {
			mixpanel.identify(props.user.email)
			mixpanel.track('Technician - Click on Convert to Project', { JobId: props.job.id })
		}
		showFillHourSection(true)
	}

	const styledProjectScope = (text) => {
		// First replace the literal '\n' with actual newlines

		const formattedText = text.replace(/\\n/g, '\n');


		// Then split by actual newlines and render
		return formattedText.split('\n').map((line, index) => (
			<React.Fragment key={index}>
				{line}
				{index < formattedText.split('\n').length - 1 && <br />}
			</React.Fragment>

		));
	};

	return (
		<Col xs={12}>
			{showWaitMessage && props.user.userType === 'technician' && (
				<Alert variant="info" className="w-100 mt-3">
					Estimates for Project has been sent to the customer. Waiting for the reply.
				</Alert>
			)}

			{showRejectedMessage && props.user.userType === 'technician' && !showTechnicianRejectionOptions && (
				<Alert variant="danger" className="w-100 mt-3">
					Customer rejected your Project estimates.
				</Alert>
			)}

			{showApprovalMessage && props.user.userType === 'technician' && (
				<Alert variant="success" className="w-100 mt-3">
					Project has been confirmed.
				</Alert>
			)}

			{showWaitToCustMessage && props.user.userType === 'customer' && (
				<Alert variant="info" className="w-100 mt-3">
					Project estimation is declined by you. Technician will review the estimation. Please wait for technician reply.
				</Alert>
			)}

			{showCustomerRejectionOptions && props.user.userType === 'customer' && (
				<>
					<Alert variant="warning" className="w-100 mt-3">
						<strong>Project proposal rejected.</strong> You can continue with a regular meeting or wait for the technician to submit a revised proposal.
					</Alert>
					<div className="project-rejection-options">
						<div className="d-flex flex-column gap-2">
							<Button 
								className="btn app-btn w-100 app-btn-light-blue" 
								onClick={continueWithRegularMeeting}
								disabled={isButtonDisabled}
							>
								<span />
								Continue with Regular Meeting
							</Button>
							<Button 
								className="btn app-btn w-100 app-btn-red" 
								onClick={() => props.setLeaveTheMeeting && props.setLeaveTheMeeting(true)}
								disabled={isButtonDisabled}
							>
								<span />
								End Meeting
							</Button>
						</div>
					</div>
				</>
			)}

			{showTechnicianRejectionOptions && props.user.userType === 'technician' && (
				<>
					<Alert variant="warning" className="w-100 mt-3">
						<strong>Customer rejected your proposal.</strong> What would you like to do next?
					</Alert>
					<div className="project-rejection-options">
						<div className="d-flex flex-column gap-2">
							<Button 
								className="btn app-btn w-100 notes-submit-btn" 
								onClick={() => {
									setShowTechnicianRejectionOptions(false)
									showFillHourSection(true)
									setShowLongJobButton(true)
									if (props.user) {
										mixpanel.identify(props.user.email)
										mixpanel.track('Technician - Create Revised Proposal', { JobId: props.job.id })
									}
								}}
								disabled={isButtonDisabled}
							>
								<span />
								Submit Revised Proposal
							</Button>
							<Button 
								className="btn app-btn w-100 app-btn-light-blue" 
								onClick={technicianContinueRegularMeeting}
								disabled={isButtonDisabled}
							>
								<span />
								Continue with Regular Meeting
							</Button>
							<Button 
								className="btn app-btn w-100 app-btn-red" 
								onClick={() => props.setLeaveTheMeeting && props.setLeaveTheMeeting(true)}
								disabled={isButtonDisabled}
							>
								<span />
								End Meeting
							</Button>
						</div>
					</div>
				</>
			)}

			{showApproveButtons && showContinueWithHours && props.user.userType === 'customer' && (
				<Alert variant="info" className="w-100 mt-3">
					{props.user.firstName}, please review the Project estimate below. Once approved, payment will be automatically approved through
					secure payment systems. Don't worry: this will be refunded if your technician is unable for some reason to solve your request.
				</Alert>
			)}

			{showLongJobDetails && (
				<>
					{(props.user.userType === 'customer' || props.user.userType === 'technician') && (
						<>
							{props.job.customer_approved_long_job != undefined && props.job.customer_approved_long_job === 'yes' && (
								<h5 className="mt-5">Project estimations confirmed :</h5>
							)}
							{(props.job.customer_approved_long_job === undefined ||
								(props.job.customer_approved_long_job != undefined && props.job.customer_approved_long_job === 'no')) && (
									<h5 className="mt-5">Project price summary :</h5>
								)}

							{showContinueWithMinuteMessage && props.user.userType === 'customer' && (
								<Alert variant="info" className="w-100 mt-3">
									Technician wants to convert this job to Project. Total cost of this job will be calculated by per six minute of
									job total time. <br />
									Would to like to approve?
								</Alert>


							)}

							{showContinueWithMinutes && (
								<Alert variant="info" className="w-100 mt-3">
									This Job has been converted to a Project. Charges will be applied on a fixed-hour basis.
								</Alert>
							)}

							{showContinueWithHours && (
								<>
									<h6 className="mt-2">Total Hours - {longJobHours}</h6>
									{props?.user?.userType === 'customer' && discountedCost != 0 && discountedCost !== longJobCost ? (
										<>
											<span className="mt-2 job-cost-style">Total Cost - </span>
											<strike>
												<span className="mt-2 job-cost-style">${longJobCost}</span>
											</strike>
											<span className="mt-2 job-cost-style"> ${discountedCost}</span>
										</>
									) : (
										<h6 className="mt-2">Total Cost - ${longJobCost}</h6>
									)}

									<h6 className="mt-2">Estimated job delivery time - {estimatedDeliveryTime ? new Date(estimatedDeliveryTime).toLocaleString() : 'Not specified'}</h6>
									
									<h6 className="mt-2">Total subscription minutes charged -{longJobMin}</h6>

								</>
							)}
							<br />
							{projectScope && (
								<div className="mt-3">
									<div className="d-flex align-items-center mb-2">
										<FontAwesomeIcon icon={faClipboardList} className="me-2" />
										<h6 className="mb-0">Agreed Project Scope:</h6>
									</div>
									<div className="p-3 bg-light rounded">
										<pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{styledProjectScope(projectScope)}</pre>
									</div>
								</div>
							)}
						</>
					)}

					{showApproveButtons && props.user.userType === 'customer' && (
						<>
							<Button
								className="btn app-btn w-100 mt-3 notes-submit-btn"
								onClick={approveLongJob}
								disabled={isButtonDisabled}
								title={isButtonDisabled ? isFixedJobApproved : ''}
							>
								<span />
								Approve
							</Button>

							<Button className="btn app-btn w-100 mt-3 app-btn-light-blue" onClick={rejectLongJob} disabled={isButtonDisabled}>
								<span />
								Reject
							</Button>
						</>
					)}
				</>
			)}

			{/* Condition altered to allow B2B customers to make long/job @Vinit - 11/Sep/2023 */}
			{/* {showLongJobButton && props.user.userType === 'technician' && !props.haveSubMin && ( */}
			{showLongJobButton && props.user.userType === 'technician' && (
				<Col xs={12}>
					{/* <OverlayTrigger
                        placement="right"
                        overlay={<Tooltip id="button-tooltip">Cannot convert to project due to 100% discount coupon.</Tooltip>}
                    > */}
					<Button
						className="btn app-btn notes-submit-btn w-100 mt-3 p-0"
						onClick={openFillHourSection}
						disabled={isFullDiscountCoupon} // This disables the button
					>
						<span />
						Convert call to a project
					</Button>
					{/* </OverlayTrigger> */}
				</Col>
			)}

			{fillHourSection && props.user.userType === 'technician' && (
				<Col xs={12}>
					{/* Project Scope Text Area */}
					<div className="mt-4 w-100">
						<label className="issue-list-item">
							Please provide detailed scope of work that will be completed within the estimated time:
							<FontAwesomeIcon
								icon={faInfoCircle}
								className="ms-2"
								title="Clearly define what will be delivered to avoid scope creep"
							/>
						</label>
						<textarea
							className={`form-control ${showProjectScopeError ? 'is-invalid' : ''}`}
							rows="4"
							value={projectScope}
							onChange={(e) => {
								setProjectScope(e.target.value)
								setShowProjectScopeError(false)
							}}
							placeholder="List all deliverables and specific tasks that will be completed..."
						/>

						{showProjectScopeError && (
							<div className="invalid-feedback">
								Please provide detailed project scope before proceeding
							</div>
						)}

					</div>

					<div className="mt-4 w-100">
						<label className="issue-list-item">
							Please provide an estimate of how long this job will take. This will help determine the price of this call.
						</label>
						<input
							type="number"
							onChange={changeHourValue}
							className="hoursClassInput form-control"
							placeholder="Please enter a number of hours."
							value={hoursValue}
						/>
					</div>

							<div className="mt-4 w-100">
								<label className="issue-list-item">When can it be delivered</label>
								<input
									type="datetime-local"
									onChange={checkEstimtedTime}
									className="hoursClassInput form-control"
									placeholder="Select delivery date and time"
									value={estimatedTime}
									min={new Date(Date.now() + 2 * 60 * 60 * 1000).toISOString().slice(0, 16)}
								/>
							</div>
							<label className="cost-cal-label">
								<i>Select expected delivery date and time (minimum 2 hours from now)</i>
							</label>

					<Button className="btn app-btn w-100 mt-3 notes-submit-btn" onClick={sendHoursToCustomer} disabled={isButtonDisabled}>
						<span />
						Ready to continue?
					</Button>
				</Col>
			)}
		</Col>
	)
}

export default LongJobDetails